
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherSalesGrid extends Serenity.EntityGrid<GiftVoucherSalesRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherSales'; }
        protected getDialogType() { return GiftVoucherSalesDialog; }
        protected getIdProperty() { return GiftVoucherSalesRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherSalesRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherSalesRow.localTextPrefix; }
        protected getService() { return GiftVoucherSalesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(65);
            this.editItem(<GiftVoucherSalesRow>{
                VoucherNo: voucherNo,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                UserId: Q.Authorization.userDefinition.UserId,
                VoucherTypeId: 65,
                TransDate: now.toDateString()

            });
        }
    }
}